export default "__VITE_ASSET__CHoaX0cB__"